module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/zh-hans_5-9cede5b2ec40e8c91e5aa37a701f362c.jpg";